import React from 'react';

import type { ISVGEditor } from '@core/app/actions/beambox/svg-editor';
import TopBarIcons from '@core/app/icons/top-bar/TopBarIcons';
import { useIsMobile } from '@core/app/stores/screenStore';
import historyUtils from '@core/app/svgedit/history/utils';
import { getSVGAsync } from '@core/helpers/svg-editor-helper';
import useI18n from '@core/helpers/useI18n';

import styles from './CommonTools.module.scss';

let svgEditor: ISVGEditor;

getSVGAsync((globalSVG) => {
  svgEditor = globalSVG.Editor;
});

interface Props {
  hide: boolean;
}

function CommonTools({ hide }: Props): React.ReactNode {
  const t = useI18n().topbar.menu;
  const isMobile = useIsMobile();

  if (hide) {
    return null;
  }

  return (
    <div className={styles['common-tools-container']}>
      <button
        className={styles.button}
        onClick={() => historyUtils.undo({ checkShortCutsScope: false })}
        title={t.undo}
      >
        <TopBarIcons.Undo />
      </button>
      <button
        className={styles.button}
        onClick={() => historyUtils.redo({ checkShortCutsScope: false })}
        title={t.redo}
      >
        <TopBarIcons.Redo />
      </button>
      {!isMobile && (
        <button className={styles.button} onClick={() => svgEditor.deleteSelected()} title={t.delete}>
          <TopBarIcons.Trash />
        </button>
      )}
    </div>
  );
}

export default CommonTools;
